import type { BackdropVideo } from '@typings/content';

/**
 * The home page's background videos, served from `public/videos/` so the
 * bundler never touches them.
 *
 * Web encodes of the 4K masters in `src/assets/Videos/` (git-ignored). Each
 * is a seamless 15.5s loop: the master's opening build from black is cut,
 * and its last 1.5s cross-fades into its first, so the loop point never
 * flashes. Re-encode with the ffmpeg command in ARCHITECTURE.md if a master
 * changes.
 *
 * Sources are tried in order: phones take the 720p file, every other
 * screen the 1080p one. Each poster is its loop's first frame, so the
 * switch from still to motion is invisible.
 */

/** Behind the hero: a data-streaked globe (bgvid.mp4). 5.8 / 2.5 MB. */
export const HERO_VIDEO: BackdropVideo = {
  poster: '/videos/hero-poster.webp',
  sources: [
    { src: '/videos/hero-loop-720.mp4', media: '(max-width: 767px)' },
    { src: '/videos/hero-loop-1080.mp4' },
  ],
};

/** Behind the rest of the page, once the hero has gone (bgvid2.mp4). */
export const PAGE_VIDEO: BackdropVideo = {
  poster: '/videos/page-poster.webp',
  sources: [
    { src: '/videos/page-loop-720.mp4', media: '(max-width: 767px)' },
    { src: '/videos/page-loop-1080.mp4' },
  ],
};
